import { AB_TESTS, abVariant } from "@/lib/abTests";

/**
 * Le chargement du script Umami, insere par l'application plutot qu'ecrit
 * dans le gabarit : son `data-tag` porte les variantes A/B du visiteur, et
 * le script ne lit cet attribut qu'une fois, a son chargement. Le tag colle
 * alors a chaque page vue et a chaque evenement de la visite, et tous les
 * rapports Umami — funnel, objectifs, repartition — se filtrent par variante.
 */
const UMAMI_SRC = "https://cloud.umami.is/script.js";
const UMAMI_WEBSITE_ID = "18c840ce-6799-4062-a5c6-b73d166d7567";
// Ne compte que la production. Sur localhost, l'adresse du reseau local ou le
// domaine technique de l'hebergeur, ni les pages vues ni les evenements
// (umami.track) ne partent.
const UMAMI_DOMAINS = "dartsync.com";

// Umami ne garde que 50 caracteres de tag (colonne VarChar(50)).
export const UMAMI_TAG_MAX = 50;

/**
 * Le tag de la visite : chaque test et sa variante, par ordre alphabetique,
 * par exemple `feedbackTest-B`, ou `feedbackTest-B_homeTest-A` a plusieurs.
 * Dans Umami, un filtre « Tag contient feedbackTest-B » isole une variante.
 *
 * Tire donc toutes les variantes des l'arrivee du visiteur : le tag doit
 * etre connu avant le chargement du script.
 */
export function abTag(options = {}) {
    const tests = options.tests ?? AB_TESTS;
    return Object.keys(tests)
        .sort()
        .map((test) => `${test}-${abVariant(test, options)}`)
        .join("_");
}

export function loadUmami({ doc = document, search = window.location.search } = {}) {
    const script = doc.createElement("script");
    script.defer = true;
    script.src = UMAMI_SRC;
    script.setAttribute("data-website-id", UMAMI_WEBSITE_ID);
    script.setAttribute("data-domains", UMAMI_DOMAINS);
    const tag = abTag({ search });
    if (tag) script.setAttribute("data-tag", tag);
    doc.head.appendChild(script);
    return script;
}
